import { render, staticRenderFns } from "./Twitter.vue?vue&type=template&id=56e797da&"
import script from "./Twitter.vue?vue&type=script&lang=js&"
export * from "./Twitter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56e797da')) {
      api.createRecord('56e797da', component.options)
    } else {
      api.reload('56e797da', component.options)
    }
    module.hot.accept("./Twitter.vue?vue&type=template&id=56e797da&", function () {
      api.rerender('56e797da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/channels/Twitter.vue"
export default component.exports